import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
    const tiles = [
        {
            title: "Events",
            description: "View and manage events.",
            href: "/dashboard/events",
            isExternal: false,
        },
        {
            title: "Coaches",
            description: "Manage coaches and profiles.",
            href: "/dashboard/coaches",
            isExternal: false,
        },
        {
            title: "Live Site",
            description: "View the public website.",
            href: "https://www.federationskatingclub.ca/",
            isExternal: true,
        },
    ];

    return (
        <div className="p-6">
            <h1 className="text-3xl font-bold mb-4 text-gray-900 dark:text-white">
                Welcome to Your Dashboard
            </h1>

            <p className="text-gray-700 dark:text-gray-300 mb-6">
                This is the main dashboard overview. Here you can manage your content, settings, and more.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {tiles.map((tile, idx) => {
                    const classes = `block bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 transition-all duration-200 hover:shadow-lg hover:border-l-4 hover:border-red-500 hover:scale-[1.02]`;
                    const content = (
                        <>
                            <h2 className="text-xl font-semibold text-gray-900 dark:text-black mb-2">
                                {tile.title}
                            </h2>
                            <p className="text-gray-600 dark:text-gray-400">
                                {tile.description}
                            </p>
                        </>
                    );

                    return tile.isExternal ? (
                        <a
                            key={idx}
                            href={tile.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes}
                        >
                            {content}
                        </a>
                    ) : (
                        <Link key={idx} to={tile.href} className={classes}>
                            {content}
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default Home;
